export interface Resource {
  id: number;
  name: string;
  description: string;
  dedicatedPartyHost: boolean;
  price: number;
}
